/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
} from "@repo/ui";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import Layout from "components/layout";
import {
  useEditInterBranchServiceJob,
  useGetInterBranchServiceDetails,
} from "utils/apis/inter-branch.api";
import B2BJobEditCard from "./inter-branch-edit-card";
import ConsignmentsDetail from "components/consignmentsDetail";
import B2BJobCompletionCard from "./inter-branch-completion-card";
import { UserContext } from "utils/reducers/user";

export default function InterBranchDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = useContext(UserContext);

  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const { data: request } = useGetInterBranchServiceDetails(state);

  const childRef: any = useRef();
  const editRef: any = useRef();

  let statusList: any = [];

  if (request?.status === "Open") {
    statusList = [
      {
        id: "Cancelled",
        text: "Cancel",
      },
    ];
  } else if (request?.status === "Awaiting Collection") {
    statusList = [
      {
        id: "Collected",
        text: "Collected",
      },
      {
        id: "Pending",
        text: "Pending",
      },
    ];
  } else if (
    request?.status === "Awaiting Delivery" ||
    request?.status === "Out for Delivery"
  ) {
    statusList = [
      {
        id: "Completed",
        text: "Completed",
      },
      {
        id: "Pending",
        text: "Pending",
      },
    ];
  } else if (request?.status === "Pending" && request?.consignmentsCollected) {
    statusList = [
      {
        id: "Forwarded",
        text: "Forward",
      },
      {
        id: "Holded",
        text: "Hold",
      },
    ];
  } else if (request?.status === "Pending" && !request?.consignmentsCollected) {
    statusList = [
      {
        id: "Cancelled",
        text: "Cancel",
      },
      {
        id: "Holded",
        text: "Hold",
      },
    ];
  }

  const {
    mutate: editServiceJob,
    isSuccess: isEditSuccess,
    isPending: editLoading,
  } = useEditInterBranchServiceJob();

  const handleUpdateStatus = (e: any) => {
    e.stopPropagation();
    if (isEdit) setIsEdit(false);
    else setIsUpdateStatus(!isUpdateStatus);
  };

  useEffect(() => {
    if (!state?.requestId) {
      navigate("/inter-branch-services");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isEditSuccess) {
      setIsEdit(false);
    }
  }, [isEditSuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/inter-branch-services">Inter Branch </Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Inter Branch Details</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="my-5 mx-4">
        <CardContent className="p-4">
          <Accordion
            type="single"
            collapsible={!isUpdateStatus}
            defaultValue="item-1"
          >
            <AccordionItem value="item-1">
              <AccordionTrigger className="font-semibold gap-4 [&[data-state=closed]>div>button]:hidden">
                Service Detail
                <div className="flex flex-1 justify-end gap-4">
                  {!isEdit &&
                  !isUpdateStatus &&
                  (!["closed", "cancelled", "completed"].includes(
                    request?.status?.toLowerCase() as string,
                  ) ||
                    (["Completed"].includes(request?.status) &&
                      user.Roles?.split(", ").includes("P&A Supervisor"))) ? (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsEdit(true);
                      }}
                      isLoading={editLoading}
                    >
                      Edit Request
                    </Button>
                  ) : null}
                  {/* {!isUpdateStatus &&
                    !isEdit &&
                    !["closed", "cancelled"].includes(
                      request?.status?.toLowerCase() as string,
                    ) &&
                    !(
                      request?.status === "Pending" &&
                      request?.movedToOnwardLocation
                    ) && (
                      <Button
                        variant="outline"
                        className="hide"
                        onClick={handleUpdateStatus}
                        disabled={editLoading}
                      >
                        Change Status
                      </Button>
                    )} */}

                  {isUpdateStatus || isEdit ? (
                    <>
                      <Button
                        variant="destructive"
                        className="w-[140px]"
                        type="button"
                        onClick={handleUpdateStatus}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="outline"
                        className="w-[140px]"
                        onClick={(e) =>
                          isEdit
                            ? editRef?.current?.onBtnConfirmClicked(e)
                            : childRef?.current?.onBtnConfirmClicked(e)
                        }
                      >
                        Save
                      </Button>
                    </>
                  ) : null}
                </div>
              </AccordionTrigger>
              <AccordionContent>
                {request ? (
                  <B2BJobEditCard
                    ref={editRef}
                    request={request}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    onConfirmEdit={editServiceJob}
                  />
                ) : null}
              </AccordionContent>
            </AccordionItem>
            {!isUpdateStatus ? (
              <>
                <AccordionItem value="item-2">
                  <AccordionTrigger className="font-semibold">
                    Packed Consignments
                  </AccordionTrigger>
                  <AccordionContent>
                    <ConsignmentsDetail
                      request={request}
                      consignments={{
                        containers: request?.packedConsignments || [],
                      }}
                      type="InterBranch"
                      defaultBagType="AED"
                    />
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-3">
                  <AccordionTrigger className="font-semibold">
                    Collected Consignments
                  </AccordionTrigger>
                  <AccordionContent>
                    <AccordionContent title="">
                      <div className="px-4 pb-4">
                        <ConsignmentsDetail
                          request={request}
                          consignments={request?.collectedConsignments}
                          type="InterBranch"
                          isAddConsignment={false}
                          defaultBagType="AED"
                        />
                      </div>
                    </AccordionContent>
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-4">
                  <AccordionTrigger className="font-semibold">
                    Delivery Consignments
                  </AccordionTrigger>
                  <AccordionContent title="Delivery Details">
                    <div className="px-4 pb-4">
                      <ConsignmentsDetail
                        request={request}
                        consignments={request?.deliveredConsignments}
                        type="InterBranch"
                        isAddConsignment={false}
                        defaultBagType="AED"
                      />
                    </div>
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-5">
                  <AccordionTrigger className="font-semibold">
                    Logs
                  </AccordionTrigger>
                  <AccordionContent title="Logs">
                    <Grid data={request?.logs}>
                      <GridColumn field="operation" title="Action" />
                      <GridColumn
                        field="operationTime"
                        title="Date & Time"
                        width="220"
                        className="text-center"
                      />
                      <GridColumn field="user" title="Updated By" width="320" />
                      <GridColumn field="remarks" title="Remarks" />
                    </Grid>
                  </AccordionContent>
                </AccordionItem>
              </>
            ) : null}
          </Accordion>
          {isUpdateStatus ? (
            <B2BJobCompletionCard
              ref={childRef}
              request={request}
              statusList={statusList}
              statusUpdated={setIsUpdateStatus}
            />
          ) : null}
        </CardContent>
      </Card>
    </Layout>
  );
}
